import { createApp } from 'vue'
import App from './App.vue'
import Clipboard from 'v-clipboard'

import './css/style.css'
import './css/styles.css'


createApp(App)
  .use(Clipboard)
  .mount('#app')
